import type { ComponentType } from 'react'
import { useLingui } from '@lingui/react/macro'
import { Trash2Icon } from 'lucide-react'
import { NAVIGATION_ICONS, SparklesIcon } from '../shared/navigation-config'

/**
 * The sample notice's body, shared by the dialog (sample-notice-dialog.tsx) and its pending skeleton, which paints
 * the same words since none of them wait on data. Drawn with the welcome guide's pieces (welcome-content.tsx), the
 * dialog it opens before. Kept light: the route's pendingComponent is eager.
 */

export const SAMPLE_NOTICE_DIALOG_CLASS = 'flex flex-col gap-0 p-0 sm:max-w-[27rem]'

export const SAMPLE_NOTICE_FOOTER_CLASS = 'px-6 pb-6'

export function SampleNoticeContent() {
  const { t } = useLingui()
  const Icon = NAVIGATION_ICONS.employees
  const notes: { icon: ComponentType<{ className?: string; strokeWidth?: number }>; text: string }[] = [
    { icon: SparklesIcon, text: t`Use them to explore and get to know D’Anchiano’s features.` },
    { icon: Trash2Icon, text: t`You can delete them whenever you want.` },
  ]
  return (
    <div className="flex flex-col items-center gap-6 px-6 pt-8 pb-6">
      <div className="flex size-12 items-center justify-center rounded-xl bg-emerald-500/10 text-emerald-500">
        <Icon className="size-6" />
      </div>
      <p className="text-center text-base leading-relaxed text-balance">
        {t`This version includes, as examples, the psychographic profiles of leading executives at technology companies, generated from their public digital footprint.`}
      </p>
      <ul className="flex w-full flex-col gap-2">
        {notes.map((note) => (
          <li key={note.text} className="bg-card flex items-center gap-3 rounded-xl border p-3">
            <div className="bg-muted text-foreground/70 flex size-9 shrink-0 items-center justify-center rounded-lg">
              <note.icon className="size-[18px]" strokeWidth={1.5} />
            </div>
            <span className="text-muted-foreground text-sm">{note.text}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
